module.exports = __webpack_public_path__ + "img/nav-ppr.00c16b43.svg";